var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgYoutube = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M18.91 4.072c.31.31.534.697.649 1.121.66 2.66.508 6.859.012 9.62a2.514 2.514 0 0 1-1.77 1.77c-1.552.424-7.798.424-7.798.424s-6.247 0-7.799-.424a2.514 2.514 0 0 1-1.77-1.77c-.664-2.647-.482-6.85-.013-9.607a2.514 2.514 0 0 1 1.77-1.77C3.743 3.013 9.99 3 9.99 3s6.246 0 7.798.423a2.52 2.52 0 0 1 1.122.65Zm-5.726 5.931-5.182 3.002V7.002l5.182 3.001Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgYoutube);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/youtube.6c3bc2cca5c0ecaf9e9954e230b6d630.svg";